import { Component, OnInit } from '@angular/core';
import { ContractorService } from '../contractor.service';
import { ContractorTypeService } from '../../contractor_types/contractor-type.service';
import { TarifNameService } from '../../tarifs/tarif-name.service';
// import { FilterComponent } from '../../../../utils/filter/filter.component';
import { Contractor } from '../contractor';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';
import { GlobalDataService } from '../../../../services/global-data.service';

export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.css'],
  providers: [
    ContractorService,
    ContractorTypeService,
    TarifNameService
  ]
})
export class ContractorComponent implements OnInit {

  contractors: Contractor[];
  pagination: Pagination;
  searchFilter: any = [];
  searchColumn: any = [];
  tariffNameList: any = [];
  contractorList: any = [];
  loading: boolean = false;
  activePage:number=0;
  msgs: Message[] = [];
  filterDialog: boolean = false;
  glb: string;

  constructor(
    private contractorService: ContractorService,
    private contractorTypeService: ContractorTypeService,
    private tarifNameService: TarifNameService,
    private router: Router,
    private global: GlobalDataService
  ) {

    // this.glb = this.global.data['key'];
  }
  
  ngOnInit() {
    
    this.fillSearchColumn();
    this.pagination = {current_page: 1,per_page: 1,last_page: 1};
    
    if(this.global.type=="contractor"){
      this.searchFilter= this.global.filter || this.searchFilter;
      this.pagination = this.global.page ||  this.pagination;
    }
    
    this.loadContractors(this.searchFilter,this.pagination.current_page);
    this.init();

  }

  loadContractors(filter: any[],page: number = 1) {
    this.loading = true;
    this.contractorService.getContacrtorByFilter(filter,page).subscribe(response => {
      this.contractors = response['data'];

       this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};
       this.activePage=this.pagination.first_item || 1;

       this.global.filter=filter;
       this.global.page=this.pagination;
       this.global.type="contractor";
       this.loading = false; 
      });
  }

 
  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Название", value: { column: "name", type: "textbox" } });
    this.searchColumn.push({ label: "Тариф", value: { column: "tariff_name_id", type: "dropdown" , value:  this.tariffNameList} });
    this.searchColumn.push({ label: "Тип", value: { column: "contractor_type_id", type: "dropdown",value: this.contractorList } });
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }

 
  setFilter(data){
    this.searchFilter=data;
    this.loading = true;
    this.loadContractors(this.searchFilter,1);
  }

  init() {
    this.tarifNameService.getTarifName(1).subscribe(response => {
      this.tariffNameList = response['data'].map(value => {
        return { label: value.name, value: { value: value.id, label: value.name } };
      })
      this.fillSearchColumn();
    });
    this.contractorTypeService.getContractorTypeList().subscribe(response => {
      this.contractorList = response['data'].map(value => {
        return { label: value.name, value: { value: value.id, label: value.name } };
      })
      this.fillSearchColumn();
    })
  }



  onPaginate(event) {
    event.page = event.page + 1
    this.pagination.current_page= event.page;
    this.loadContractors(this.searchFilter,event.page);
  }

  add(): void {
    this.router.navigate(['dashboard/contractor-crud']);
  }

  edit(id: any) {
    this.router.navigate(['dashboard/contractor-crud/', id]);
  }

  pay(id: any) {
    this.router.navigate(['dashboard/account/', id]);
  }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contractors/contractor/contractor.component.ts